var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFavoriteDiploma = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 7.74826V11.9094C15.5 14.4899 15.5 15.7801 14.8882 16.3439C14.5965 16.6128 14.2282 16.7817 13.8359 16.8266C13.0133 16.9207 12.0527 16.0711 10.1315 14.3719C9.28232 13.6207 8.85771 13.2452 8.36643 13.1462C8.12452 13.0975 7.87548 13.0975 7.63356 13.1462C7.14229 13.2452 6.71768 13.6207 5.86847 14.3719C3.94728 16.0711 2.98668 16.9207 2.1641 16.8266C1.77179 16.7817 1.40351 16.6128 1.11176 16.3439C0.5 15.7801 0.5 14.4899 0.5 11.9094V7.74826C0.5 4.17441 0.5 2.38749 1.59835 1.27724C2.6967 0.166992 4.46447 0.166992 8 0.166992C11.5355 0.166992 13.3033 0.166992 14.4016 1.27724C15.5 2.38749 15.5 4.17442 15.5 7.74826ZM4.875 3.50033C4.875 3.15515 5.15482 2.87533 5.5 2.87533H10.5C10.8452 2.87533 11.125 3.15515 11.125 3.50033C11.125 3.8455 10.8452 4.12533 10.5 4.12533H5.5C5.15482 4.12533 4.875 3.8455 4.875 3.50033Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFavoriteDiploma);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/favoriteDiploma.e6f60861c8c781978f46626a7c613a8e.svg";